/**
 * Global Frontend JS – Sage 10 Compatible (Vite)
 * Runs globally (imported via resources/js/app.js)
 */

import $ from 'jquery';
import 'foundation-sites';
import 'slick-carousel';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Pattern2 from '@images/pattern-v2.png';
import Pattern from '@images/pattern.png';
import PatternFlat from '@images/pattern-flat.png';
import Cap from '@images/cap.svg';
import Cap2 from '@images/cap.png';
import Neon3 from '@images/Neon-03.svg';
import mqBg from '@images/marquee-bg.png';
import mqFaq from '@images/marquee-faq.webp';
import Loader from '@images/ajax-loader.gif';
import Decorations from '@images/home-decorations.png';
import Waves from '@images/macro-waves.png';

import Partners from './components/partners';
import Resources from './components/resources';

window.$ = window.jQuery = $;

gsap.registerPlugin(ScrollTrigger);
gsap.config({ nullTargetWarn: false });

$(document).ready(function () {
  console.log('✅ Global frontend JS initialized');

  // Initialize Foundation
  $(document).foundation();

  // -------------------------------
  // AOS Initialization
  // -------------------------------
  function initAOS() {
    if (typeof AOS !== 'undefined') {
      console.log('🎬 Initializing AOS…');
      AOS.init({
        once: true,
        offset: 160,
        duration: 400,
        easing: 'ease-out-sine',
      });
    }
  }

  initAOS();

  setTimeout(() => {
    if (typeof AOS !== 'undefined') {
      AOS.refreshHard();
      console.log('♻️ AOS refreshed');
    }
  }, 500);

  // Partners Component Init
  if (typeof Partners?.init === 'function') {
    Partners.init();
  }

    // Resources Component Init
  if (typeof Resources?.init === 'function') {
    Resources.init();
  }

  // -------------------------------
  // Modal (ACQ) Initialization
  // -------------------------------
  // if (!sessionStorage.getItem('acqModalDismissed')) {
  //   const modal = new Foundation.Reveal($('#acq'));
  //   setTimeout(() => {
  //     modal.open();
  //   }, 1000);
  // }

  // Modal (ACQ) Initialization — safe guard
  (function () {
    const $acq = $('#acq');
    if ($acq.length && !sessionStorage.getItem('acqModalDismissed')) {
      const modal = new Foundation.Reveal($acq);
      setTimeout(() => modal.open(), 1000);
    }
  })();


  // -------------------------------
  // Assessment Tool Logic
  // -------------------------------

  function scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    return false;
  }

  $(document).ready(function () {
    // Capture the initial Marketo org value
    let organizationValue = $('form.mktoForm input[name="MM_1_Description_of_Organization__c"]').val();

    if (!organizationValue) {
      setTimeout(() => {
        organizationValue = $('form.mktoForm input[name="MM_1_Description_of_Organization__c"]').val();
      }, 1000);
    }

    if ($('.assessment_tool').length >= 1) {
      const max = parseInt($('.assessment_tool').attr('data-max'), 10);
      const prog = Math.ceil(100 / max);

      $(document).on('click', '.ass-next:not(.disabled)', function (e) {
        e.preventDefault();
        const next = parseInt($(this).attr('data-next'), 10);
        const section = parseInt($('.ass-panel[data-panel="' + next + '"]').attr('data-section'), 10);

        if (next <= max) {
          if (parseInt($('.ass-time-section.active').attr('data-section'), 10) !== section) {
            $('.ass-time-section.active').removeClass('active');
            $('.ass-time-section[data-section="' + section + '"]').addClass('active');
          }

          $('.ass-panel.active').removeClass('active');
          $('.ass-panel[data-panel="' + next + '"]').addClass('active');

          if (
            $('.ass-panel[data-panel="' + next + '"]').attr('data-type') !== 'section' &&
            $('.ass-panel[data-panel="' + next + '"]').attr('data-answered') === 'no'
          ) {
            $(this).addClass('disabled');
          }

          const progress = next * prog;
          $('.ass-progress .progress-blur').css('width', progress + 'vw');
          $('.ass-progress .progress-line').css('width', progress + 'vw');

          if (next === max) {
            $(this).addClass('hidden');
            $('.ass-finish').removeClass('hidden');
          } else {
            const updatedNext = next + 1;
            $(this).attr('data-next', updatedNext);

            $('.ass-prev').attr('data-prev', updatedNext - 2);
            if (updatedNext - 1 > 0) {
              $('.ass-prev').removeClass('disabled');
            } else {
              $('.ass-prev').addClass('disabled');
            }
          }
        }

        scrollToTop();
      });

      $(document).on('click', '.ass-prev:not(.disabled)', function (e) {
        e.preventDefault();
        const prev = parseInt($(this).attr('data-prev'), 10);
        const section = parseInt($('.ass-panel[data-panel="' + prev + '"]').attr('data-section'), 10);

        if (prev >= 1) {
          if (parseInt($('.ass-time-section.active').attr('data-section'), 10) !== section) {
            $('.ass-time-section.active').removeClass('active');
            $('.ass-time-section[data-section="' + section + '"]').addClass('active');
          }

          $('.ass-panel.active').removeClass('active');
          $('.ass-panel[data-panel="' + prev + '"]').addClass('active');

          const updatedPrev = prev - 1;
          $(this).attr('data-prev', updatedPrev);

          const progress = updatedPrev * prog;
          $('.ass-progress .progress-blur').css('width', progress + 'vw');
          $('.ass-progress .progress-line').css('width', progress + 'vw');

          if (updatedPrev - 1 <= 0) {
            $('.ass-prev').addClass('disabled');
          }

          $('.ass-next').attr('data-next', updatedPrev + 2);
          $('.ass-next.disabled').removeClass('disabled');
          $('.ass-finish:not(.hidden)').addClass('hidden');
          $('.ass-next.hidden').removeClass('hidden');
        }

        scrollToTop();
      });

      $(document).on('click', '.ass-answer', function (e) {
        e.preventDefault();
        const type = $(this).attr('data-type');
        const question = $(this).attr('data-question');
        const qGroup = $(this).attr('data-group');
        const count = $(this).attr('data-group-count');

        if (count > 1) {
          $('.ass-panel[data-question="' + question + '"] .ass-answer-group[data-group="' + qGroup + '"]').attr('data-answered', 'yes');
          let acount = 0;
          $('.ass-panel[data-question="' + question + '"] .ass-answer-group').each(function () {
            if ($(this).attr('data-answered') === 'yes') acount++;
          }).promise().done(function () {
            if (acount === count) {
              $('.ass-panel[data-question="' + question + '"]').attr('data-answered', 'yes');
              $('.ass-next.disabled').removeClass('disabled');
            }
          });
        } else {
          $('.ass-panel[data-question="' + question + '"]').attr('data-answered', 'yes');
          $('.ass-next.disabled').removeClass('disabled');
        }

        if (type !== 'checkbox') {
          if (!$(this).hasClass('selected')) {
            $('.ass-answer-group[data-question="' + question + '"][data-group="' + qGroup + '"] > .ass-answer.selected').removeClass('selected');
          }
        }

        $(this).toggleClass('selected');
      });

      const formIDs = [
        'MM_1_Description_of_Organization__c',
        'MM_2A_Member_Population_Type__c',
        'MM_2_B_Member_Population_Size__c',
        'MM_3_Type_of_Members_in_Population__c',
        'MM_4_Member_Population_Makeup__c',
        'MM_5_Primary_Growth_Strategy__c',
        'MM_6_Segment_of_Population_Growth__c',
        'MM_7_Current_Number_of_HMPs__c',
        'MM_8_Current_Implementation_Time__c',
        'MM_9_Data_Send_Types__c',
        'MM_10_Price_Transparency_Awareness__c',
        'MM_11_Data_Analyzation_Tools__c',
        'MM_12_Using_Analytic_Platforms__c',
        'MM_13_Benchmarking_Data_Usage__c',
        'MM_14_Transparency_Confidence__c',
        'MM_15_Confidence_Member_Info_Access__c',
        'MM_Result__c',
      ];

      $(document).on('click', '.ass-finish', function (e) {
        e.preventDefault();
        $(this).addClass('disabled');

        let con = 0,
          opt = 0,
          url = $(this).attr('data-result-page'),
          conV = '',
          optV = '';

        $('.ass-answer.selected').each(function (index) {
          let answer = $(this).text().trim();

          if (index > 0 && formIDs[index - 1] === formIDs[index]) {
            const currentVal = $('form.mktoForm input[name="' + formIDs[index] + '"]').val();
            answer = currentVal ? currentVal + ', ' + answer : answer;
          }

          if (index < formIDs.length) {
            const input = formIDs[index];
            $('form.mktoForm input[name="' + input + '"]').val(answer);
          }
        }).promise().done(function () {
          optV = opt > 10 ? 'optimized' : 'unoptimized';
          conV = con > 3 ? 'connected' : 'disconnected';
          $('form.mktoForm input[name="MM_Result__c"]').val(optV + '-' + conV);

          if (organizationValue) {
            $('form.mktoForm input[name="MM_1_Description_of_Organization__c"]').val(organizationValue);
            MktoForms2.whenReady(function (form) {
              form.setValues({
                MM_1_Description_of_Organization__c: organizationValue,
              });
            });
          }

          $('#ass-thankyou').attr('data-url', url + '?ao=' + optV + '&ac=' + conV);
          $('form.mktoForm button.mktoButton').click();
        });
      });
    }
  });

  function waitForMktoForms2(callback) {
    const check = setInterval(() => {
      if (typeof window.MktoForms2 !== 'undefined') {
        clearInterval(check);
        callback(window.MktoForms2);
      }
    }, 200);
  }

  // Wrap both MktoForms2 usages
  waitForMktoForms2((MktoForms2) => {
    MktoForms2.whenReady((form) => {
      form.onSuccess((vals, tyURL) => {
        document.location.href = $('#ass-thankyou').attr('data-url');
        return false;
      });
    });
  });


    // -------------------------------
  // AJAX "Load More" — Posts
  // -------------------------------

  $(document).on('click', '.load-more', function (e) {
    e.preventDefault();

    const id = $(this).attr('data-section');
    const postType = $(this).attr('data-post-type');
    const contains = $(this).attr('data-contains');
    const tag = $(this).attr('data-tag');
    const current = parseInt($(this).attr('data-current'), 10);
    const max = $(this).attr('data-max');
    const exclude = $(this).attr('data-exclude') || '';

    console.log('Loading more posts for section:', id);

    $('.load-more').attr('data-contains', contains);
    $('.load-more').attr('data-tag', tag);
    $('#' + id + ' .load-more').hide();
    $('#' + id + ' .pagination-count svg').show();
    $('#' + id + ' .pagination-count .no-posts').hide();

    $.ajax({
      url: ajaxurl + '?action=loadMorePosts',
      type: 'post',
      data: {
        section: id,
        postType,
        contains,
        tag,
        current,
        exclude,
      },
      success: function (data) {
        const dataArray = JSON.parse(data);
        const newCurrent = parseInt(dataArray['current'], 10);
        const newId = dataArray['id'];
        const newMax = parseInt(dataArray['max'], 10);

        console.log('Appending posts to:', newId);

        $('#' + newId + ' .current-page').html(newCurrent);
        $('.load-more').attr('data-current', newCurrent);
        $('.load-more').attr('data-max', newMax);
        $('#' + newId + ' .pf-filter-list').append(dataArray['html']);

        setTimeout(() => AOS.refresh(), 200);
        setTimeout(() => $('#' + newId + ' .pf-post-card:not(.aos-animate)').addClass('aos-animate'), 400);

        $('#' + newId + ' .pagination-count svg').hide();

        if (newCurrent >= newMax) {
          $('#' + newId + ' .pagination-count .no-posts').show();
        } else {
          $('#' + newId + ' .load-more').show();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('AJAX Load More Error:', textStatus, errorThrown);
      },
    });
  });

  // -------------------------------
  // AJAX "Load More" — Media
  // -------------------------------

  $(document).on('click', '.load-more-media', function (e) {
    e.preventDefault();

    const id = $(this).attr('data-section');
    const postType = $(this).attr('data-post-type');
    const contains = $(this).attr('data-contains');
    const tag = $(this).attr('data-tag');
    const current = parseInt($(this).attr('data-current'), 10);
    const max = $(this).attr('data-max');

    console.log('Loading more media for section:', id);

    $('.load-more-media').attr('data-contains', contains);
    $('.load-more-media').attr('data-tag', tag);
    $('#' + id + ' .load-more-media').hide();
    $('#' + id + ' .pagination-count-media svg').show();
    $('#' + id + ' .pagination-count-media .no-posts').hide();

    $.ajax({
      url: ajaxurl + '?action=loadMorePostsMedia',
      type: 'post',
      data: {
        section: id,
        postType,
        contains,
        tag,
        current,
      },
      success: function (data) {
        const dataArray = JSON.parse(data);
        const newCurrent = parseInt(dataArray['current'], 10);
        const newId = dataArray['id'];
        const newMax = parseInt(dataArray['max'], 10);

        console.log('Appending media to:', newId);

        $('#' + newId + ' .current-page').html(newCurrent);
        $('.load-more-media').attr('data-current', newCurrent);
        $('.load-more-media').attr('data-max', newMax);
        $('#' + newId + ' .pf-filter-list-media').append(dataArray['html']);

        setTimeout(() => AOS.refresh(), 200);
        setTimeout(() => $('#' + newId + ' .pf-post-card:not(.aos-animate)').addClass('aos-animate'), 400);

        $('#' + newId + ' .pagination-count-media svg').hide();

        if (newCurrent >= newMax) {
          $('#' + newId + ' .pagination-count-media .no-posts').show();
        } else {
          $('#' + newId + ' .load-more-media').show();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('AJAX Load More Media Error:', textStatus, errorThrown);
      },
    });
  });

  // -------------------------------
  // Slick Sliders
  // -------------------------------

  $('.mq-slide').slick({
      arrows: false,
      dots: false,
    });

    $('.video-slider').slick({
      arrows: false,
      dots: true,
    });

    $('.case-study-slider').slick({
      prevArrow:
        '<button type="button" class="slick-prev-cs" aria-label="Previous case study"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4975 1.9975L4.00916 8.5L10.4975 15.0025L8.5 17L0 8.5L8.5 0L10.4975 1.9975Z" fill="#133B5B"/></svg></button>',

      nextArrow:
        '<button type="button" class="slick-next-cs" aria-label="Next case study"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.0025L6.48833 8.5L0 1.9975L1.9975 0L10.4975 8.5L1.9975 17L0 15.0025Z" fill="#133B5B"/></svg></button>',

      dots: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      centerMode: false,

      customPaging: function () {
        return '<button type="button" class="line-dot" aria-label="Go to slide"><span></span></button>';
      },

      appendDots: $('.case-study-slider')
    });

    $('.video-title:first').addClass('highlight');

    $('.video-slider').on('afterChange', function(event, slick, currentSlide) {
      $('.video-title').removeClass('highlight');
      $('.video-title-' + currentSlide).addClass('highlight');
    });

    $('.stack-slider').slick({
      arrows: false,
      dots: true,
    });

    $('.product-card-slider').slick({
      arrows: false,
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    });

    $('.resources-slider').slick({
      prevArrow: '<button type="submit" class="slick-prev" aria-label="next resources"><svg width="21" height="47" viewBox="0 0 21 47" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: scaleX(-1);"><mask id="path-1-inside-1_1413_452" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 46.3888L21 23.1944L0 0V4.46981L16.9531 23.1944L0 41.919V46.3888Z"/></mask><path d="M0 46.3888H-33V132.005L24.463 68.5374L0 46.3888ZM21 23.1944L45.463 45.343L65.5161 23.1944L45.463 1.04584L21 23.1944ZM0 0L24.463 -22.1486L-33 -85.6163V0H0ZM0 4.46981H-33V17.1894L-24.463 26.6184L0 4.46981ZM16.9531 23.1944L41.4161 45.343L61.4692 23.1944L41.4161 1.04584L16.9531 23.1944ZM0 41.919L-24.463 19.7705L-33 29.1995V41.919H0ZM24.463 68.5374L45.463 45.343L-3.46304 1.04584L-24.463 24.2403L24.463 68.5374ZM45.463 1.04584L24.463 -22.1486L-24.463 22.1486L-3.46304 45.343L45.463 1.04584ZM-33 0V4.46981H33V0H-33ZM41.4161 1.04584L24.463 -17.6788L-24.463 26.6184L-7.50996 45.343L41.4161 1.04584ZM24.463 64.0676L41.4161 45.343L-7.50996 1.04584L-24.463 19.7705L24.463 64.0676ZM-33 41.919V46.3888H33V41.919H-33Z" fill="#0E3852" mask="url(#path-1-inside-1_1413_452)"/></svg></button>',
      nextArrow: '<button type="submit" class="slick-next" aria-label="previous resources"><svg width="21" height="47" viewBox="0 0 21 47" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_1413_452" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 46.3888L21 23.1944L0 0V4.46981L16.9531 23.1944L0 41.919V46.3888Z"/></mask><path d="M0 46.3888H-33V132.005L24.463 68.5374L0 46.3888ZM21 23.1944L45.463 45.343L65.5161 23.1944L45.463 1.04584L21 23.1944ZM0 0L24.463 -22.1486L-33 -85.6163V0H0ZM0 4.46981H-33V17.1894L-24.463 26.6184L0 4.46981ZM16.9531 23.1944L41.4161 45.343L61.4692 23.1944L41.4161 1.04584L16.9531 23.1944ZM0 41.919L-24.463 19.7705L-33 29.1995V41.919H0ZM24.463 68.5374L45.463 45.343L-3.46304 1.04584L-24.463 24.2403L24.463 68.5374ZM45.463 1.04584L24.463 -22.1486L-24.463 22.1486L-3.46304 45.343L45.463 1.04584ZM-33 0V4.46981H33V0H-33ZM41.4161 1.04584L24.463 -17.6788L-24.463 26.6184L-7.50996 45.343L41.4161 1.04584ZM24.463 64.0676L41.4161 45.343L-7.50996 1.04584L-24.463 19.7705L24.463 64.0676ZM-33 41.919V46.3888H33V41.919H-33Z" fill="#0E3852" mask="url(#path-1-inside-1_1413_452)"/></svg></button>',
      arrows: true,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $('.logo-slider-condensed').slick({
      dots: false,
      arrows: false,
      slidesToShow: 6,
      slidesToScroll: 3,
      autoplay: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      ],
    });

    $('.buckets-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      speed: 900,
      infinite: true,
      centerMode: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $('.buckets-slider-cul').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      speed: 900,
      infinite: true,
      centerMode: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $('.culture-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      aautoplaySpeed: 6000,
      speed: 900,
      infinite: true,
      //centerMode: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $('.diversity-slider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoPlaySpeed: 30000,
      infinite: true,
      centerMode: false,
    });

    $('.quote-slider-full').slick({
      prevArrow: '<button type="submit" class="slick-prev-qs" aria-label="next quote"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4975 1.9975L4.00916 8.5L10.4975 15.0025L8.5 17L-2.11793e-06 8.5L8.5 -1.74627e-07L10.4975 1.9975Z" fill="white"/></svg></button>',
      nextArrow: '<button type="submit" class="slick-next-qs" aria-label="previous quote"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.0025L6.48833 8.5L0 1.9975L1.9975 0L10.4975 8.5L1.9975 17L0 15.0025Z" fill="white"/></svg></button>',
      dots: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,

      customPaging: function() {
        return '<button type="button" class="line-dot" aria-label="Go to slide"><span></span></button>';
      },

      appendDots: $('.quote-slider-full')
    });

    $('.logo-slider').slick({
      dots: false,
      arrows: true,
      prevArrow: '<button type="submit" class="slick-prev"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="submit" class="slick-next"><i class="far fa-arrow-right"></i></button',
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
      ],
    });

    $('.sm-list').slick({
      arrows: false,
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $('.video-roundtable-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: true,
      autoplay: false,
      autoplaySpeed: 4000,
      centerMode: false,
    });
  // -------------------------------
  // Navigation + Hamburger + Smooth Scroll
  // -------------------------------

  let pstl = gsap.timeline({
    scrollTrigger: {
      trigger: '.marker',
      scrub: true,
      start: 'top 50px',
    },
  });
  pstl.to('.nav-wrap', { backgroundColor: 'rgba(0, 3, 26, 0.9)', duration: 0.5 });

  $('.smooth, .smooth a').click(function () {
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      $('.top-bar').removeClass('open');
      const target = $(this.hash);
      const t = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (t.length) {
        $('html,body').animate({ scrollTop: t.offset().top - 90 }, 1000);
        return false;
      }
    }
  });

  if ($('.expanding-image-list').length !== -1) {
    let eil = false;
    $(document).on('mouseenter', '.expanding-image-list > .columns:not(.expanded)', function () {
      if (!eil) {
        eil = true;
        window.setTimeout(() => (eil = false), 400);
        $(this).parent().find('.expanded').removeClass('expanded');
        $(this).addClass('expanded');
      }
    });
  }

  $('.no-link a').on('click', function (event) {
    event.preventDefault();
  });

  // -------------------------------
  // Nav / Hamburger Controls
  // -------------------------------

  $('.hamburger').on('click', function () {
  $(this).toggleClass('is-active');
  $('.top-bar').toggleClass('open');
  $('html').toggleClass('overflow');

  if (!$('.top-bar').hasClass('open')) {
    $('.mega-menu').removeClass('show');
    $('.has-children').removeClass('active');
  }
});


  $('.bank-wrap').on('click', function () {
    $(this).next().children('.link-bank').toggleClass('show');
  });

  const navMql = window.matchMedia('(max-width: 63.9375em)');

  $('.has-children a').on('mouseenter', function () {
    if (navMql.matches) return; 

    $(this).parent().children('.mega-menu').addClass('show');
    $(this).parent().siblings().children('.mega-menu').removeClass('show');
    $(this).parent().addClass('active');
    $(this).parent().siblings().removeClass('active');
  });

  $('.mega-menu').on('mouseleave', function () {
    if (navMql.matches) return; 
    
    $(this).parent().children('.mega-menu').removeClass('show');
    $(this).parent().siblings().children('.mega-menu').removeClass('show');
    $(this).parent().removeClass('active');
    $(this).parent().siblings().removeClass('active');
  });

  $('.wrap.container').on('click', function () {
    $('.mega-menu').removeClass('show');
    $('.has-children').removeClass('active');
  });

  // Tabs click-through
  $('.tabs-title .txt-link').on('click', function () {
    window.location.href = $(this).attr('href');
  });

  (function () {
  const mql = window.matchMedia('(max-width: 63.9375em)'); // < large

  $(document).on('click', '.top-bar .has-children > a', function (e) {
    if (!mql.matches) return; // desktop untouched

    const $li   = $(this).parent();               // li.has-children
    const $mega = $li.children('.mega-menu');     // its mega menu
    if (!$mega.length) return;

    // prevent "#" jump, and prevent your other "wrap.container" click-close from instantly firing
    e.preventDefault();
    e.stopPropagation();

    const isOpen = $li.hasClass('active') || $mega.hasClass('show');

    if (isOpen) {
      // CLOSE same item
      $li.removeClass('active');
      $mega.removeClass('show');
    } else {
      // OPEN this item (keep existing "only one open" behavior)
      $li.siblings('.has-children').removeClass('active').children('.mega-menu').removeClass('show');
      $li.addClass('active');
      $mega.addClass('show');
    }
  });

  // Optional: if user taps inside mega menu on mobile, don't bubble to wrap.container
  $(document).on('click', '.top-bar .mega-menu', function (e) {
    if (!mql.matches) return;
    e.stopPropagation();
  });
})();

  // -------------------------------
  // Accordion
  // -------------------------------

  $('.accordion-content-inner').first().css('display', 'block');
  $('.accordion-title-in').first().addClass('open');

  $('.accordion-title-in').on('click', function (event) {
    if (!$(this).hasClass('open')) {
      $('.accordion-title-in.open').removeClass('open');
      $('.accordion-content-inner').hide();

      // Open clicked accordion
      $(this).next().fadeIn();
      $(this).addClass('open');
    }
    event.preventDefault();
  });

  // -------------------------------
  // Quote Slider Scroll Animation
  // -------------------------------

  const quoteSlider = $('.quote-slider-full');

  if ($('body').hasClass('home') || $('body').hasClass('solutions-payers') || $('body').hasClass('careers')) {
    $(window).on('scroll', function () {
      const windowHeight = $(window).height();
      const scrollTop = $(window).scrollTop();
      const sectionOffset = quoteSlider.offset().top;

      if (scrollTop + windowHeight >= sectionOffset) {
        quoteSlider.addClass('animate-quotes');
      } else {
        quoteSlider.removeClass('animate-quotes');
      }
    });
  }

  // -------------------------------
  // GSAP ScrollTrigger for Videos
  // -------------------------------

  const animVideo = gsap.utils.toArray('.animation-video');
  animVideo.forEach(function (video) {
    ScrollTrigger.create({
      trigger: video,
      scroller: '.media-area',
      start: 'top center',
      end: 'bottom center',
      onEnter: () => video.play(),
      onEnterBack: () => video.play(),
      onLeave: () => video.pause(),
      onLeaveBack: () => video.pause(),
    });
  });

  // -------------------------------
  // Careers Page — Scroll to Jobs if Parameter Exists
  // -------------------------------

  if ($('body').hasClass('careers')) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('gh_jid')) {
      $('html, body').animate({ scrollTop: $('#content-job-postings').offset().top }, 1000);
    }
  }

  // -------------------------------
  // Assessment Landing Video Animations
  // -------------------------------

  if ($('body').hasClass('assessment-landing')) {
    const boxwrap = document.querySelectorAll('.box-wrap');
    const boxes = document.querySelectorAll('.box');
    const borders = document.querySelectorAll('.box .border');
    const bgs = document.querySelectorAll('.bg');

    let glowboxes = gsap.timeline({
      duration: 1,
      scrollTrigger: {
        trigger: '.section-2',
        start: 'top bottom',
      },
    });

    glowboxes
      .to(boxes, { backgroundColor: 'rgba(68, 121, 167, 0.5)', border: '3px solid #c7d4d8', duration: 1.5, stagger: 0.5, ease: 'power4.out' })
      .to(bgs, { opacity: 0.5, stagger: 0.6, duration: 1.5, ease: 'power4.out' }, '-=2')
      .to(borders, { opacity: 0.5, stagger: 0.7, duration: 1.5, ease: 'power4.out' }, '-=2.5');

    if (window.matchMedia('(max-width: 768px)').matches) {
      const vid = document.querySelector('.steps-video-mob');
      ScrollTrigger.create({
        trigger: '.section-2',
        start: 'top center',
        end: 'bottom center',
        onEnter: () => vid.play(),
        onEnterBack: () => vid.play(),
        onLeave: () => vid.pause(),
        onLeaveBack: () => vid.pause(),
      });
    } else {
      const vidmob = document.querySelector('.steps-video');
      ScrollTrigger.create({
        trigger: '.section-2',
        start: 'top 200px',
        end: 'bottom center',
        onEnter: () => vidmob.play(),
        onEnterBack: () => vidmob.play(),
        onLeave: () => vidmob.pause(),
        onLeaveBack: () => vidmob.pause(),
      });
    }
  }
  // -------------------------------
  // FAQs Page — Auto-Open Accordion Items
  // -------------------------------

  if ($('body').hasClass('faqs-payers') || $('body').hasClass('faqs-partners')) {
    console.log('🧠 FAQ accordion auto-open active');
    const accordionItems = document.querySelectorAll('.accordion-item');
    if (accordionItems.length >= 2) {
      for (let i = 0; i < 2; i++) {
        accordionItems[i].classList.add('is-active');
        const content = accordionItems[i].querySelector('.accordion-content');
        if (content) content.style.display = 'block';
      }
    }
  }

  // -------------------------------
  // Foundation Reveal Modals + Announcement Slider
  // -------------------------------

  $(document).on('open.zf.reveal', '#acq', function () {
    const $slider = $('.announcement-slider');

    // Initialize only once
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        arrows: true,
        appendArrows: $('.announcement-controls'),
        prevArrow: $('.announcement-controls .slick-prev'),
        nextArrow: $('.announcement-controls .slick-next'),
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
      });
    } else {
      $slider.slick('setPosition');
    }
  });

  const $headSlider = $('.announcement-slider-head');
  if (!$headSlider.hasClass('slick-initialized')) {
    $headSlider.slick({
      arrows: true,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
    });
  } else {
    $headSlider.slick('setPosition');
  }

  $(document).on('closed.zf.reveal', '#acq', function () {
    sessionStorage.setItem('acqModalDismissed', 'true');
    $('.nav-wrap .callout').addClass('open');
  });

  $('.announcement-slider').on('click', '.button', function () {
    sessionStorage.setItem('acqModalDismissed', 'true');
  });

  // -------------------------------
  // Forced Popup Hide Protection
  // -------------------------------

  (function () {
    if (!window.__HIDE_POPUP__) return;

    // Block any forced #acq opens
    if (window.jQuery) {
      jQuery(document).on('open.zf.reveal', '#acq', function (e) {
        e.stopImmediatePropagation();
        try {
          jQuery('#acq').foundation('close');
        } catch (_) {}
        jQuery('.reveal-overlay').remove();
        document.documentElement.classList.remove('is-reveal-open');
        return false;
      });

      jQuery(function () {
        try {
          jQuery('#acq').foundation('close');
        } catch (_) {}
        jQuery('.reveal-overlay').remove();
        jQuery('#acq').remove();
        document.documentElement.classList.remove('is-reveal-open');
      });
    } else {
      const cleanUp = () => {
        const el = document.getElementById('acq');
        if (el && el.parentNode) el.parentNode.removeChild(el);
        document.querySelectorAll('.reveal-overlay').forEach(n => n.parentNode && n.parentNode.removeChild(n));
        document.documentElement.classList.remove('is-reveal-open');
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', cleanUp);
      } else {
        cleanUp();
      }
    }
  })();

  // -------------------------------
  // Video Overlay Click-to-Play
  // -------------------------------

  document.addEventListener('click', function (e) {
    const overlay = e.target.closest('.video-frame-overlay');
    if (!overlay) return;

    overlay.style.display = 'none';
    const iframe = overlay.previousElementSibling;

    if (iframe && iframe.tagName === 'IFRAME' && iframe.src.indexOf('autoplay=1') === -1) {
      const url = new URL(iframe.src);
      url.searchParams.set('autoplay', '1');
      iframe.src = url.toString();
    }
  });

  // Mobile Nav Fix – viewport-based scroll
  $(function () {
    var $menu = $('.top-bar ul.menu');

    if (!$menu.length) {
      console.log('DEBUG: .top-bar ul.menu NOT FOUND');
      return;
    }

    var mql = window.matchMedia('(max-width: 63.9375em)');

    // Catch ANY click inside a LI
    $menu.on('click', 'li', function (e) {
      if (!mql.matches) return;

      const li = this;
      const a  = li.querySelector('a');
      const label = a ? a.textContent.trim() : '(no link)';

      console.log('%c[MOBILE MENU CLICK]',
        'color:#0f0;font-weight:bold;',
        'LI clicked:', li,
        'Label:', label,
        'scrollTop before:', $menu[0].scrollTop
      );

      // Scroll menu to top
      $menu.stop().animate({ scrollTop: 0 }, 220);
    });
  });


  // Smooth scroll — page specific
  const enableSmoothScroll =
    $('body').hasClass('resource-center') ||
    $('body').hasClass('careers')

  if (enableSmoothScroll) {
    function getHeaderOffset() {
      const $header = $('.nav-wrap:visible, header:visible').first();
      return ($header.length ? $header.outerHeight() : 0) + 12;
    }

    $(document).on('click', 'a[href^="#"]', function (e) {
      const href = this.getAttribute('href');
      if (!href || href === '#') return;

      const targetId = href.slice(1);
      const target = document.getElementById(targetId);
      if (!target) return;

      e.preventDefault();

      const top = $(target).offset().top - getHeaderOffset();
      $('html, body').stop(true).animate({ scrollTop: Math.max(0, top) }, 650, 'swing');

      if (history && history.pushState) {
        history.pushState(null, '', href);
      } else {
        window.location.hash = href;
      }
    });
  }

  // -------------------------------
  // Done
  // -------------------------------

  console.log('✅ Global Frontend JS fully initialized');
});
